import { render, staticRenderFns } from "./MotorInsuranceJeopardy.vue?vue&type=template&id=1694c0c8&scoped=true&"
import script from "./MotorInsuranceJeopardy.vue?vue&type=script&lang=js&"
export * from "./MotorInsuranceJeopardy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1694c0c8",
  null
  
)

export default component.exports